

var _factory = require("./factory");
define(['angular', 'text!./template.html', 'xo-ui-components/src/error-tooltip/directive'], function (angular, template) {
  return angular.module('xo-guest-upgrade.occupation', ['squid', 'xo-error-tooltip.directive']).directive('xoOccupation', [function () {
    return {
      template: template,
      scope: {
        user: '=?'
      },
      controller: ['$scope', '$locale', function ($scope, $locale) {
        $scope.locale = $locale;
        _factory.$OccupationFactory.occupationExp().then(function (_ref) {
          var enabled = _ref.enabled;
          $scope.occupations = enabled ? $locale.content.signup.occupations : $locale.content.signup.occupationList;
        });
      }]
    };
  }]);
});
_factory.$OccupationFactory;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-guest-components/src/guest-upgrade/occupation/directive.js
// module id = ../node_modules/xo-guest-components/src/guest-upgrade/occupation/directive.js
// module chunks = 0